import * as R from 'ramda';
import queryString from 'query-string';

export const getQueryObject = R.pipe(R.propOr('', 'search'), queryString.parse);
